import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "border-bottom mb-3" }
const _hoisted_2 = { class: "mb-3 row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "uploadReportFile",
    class: "col-form-label"
  }, "File:")
], -1)
const _hoisted_4 = { class: "col-md-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Cancel"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Save")
], -1)
const _hoisted_6 = { class: "border-bottom mb-3" }
const _hoisted_7 = { class: "mb-3 row align-items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "disabledSelect",
  class: "col-sm-3 col-form-label"
}, "Agency:", -1)
const _hoisted_9 = { class: "col-sm-9" }
const _hoisted_10 = { class: "mb-3 row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "disabledTextInput",
  class: "col-sm-3 col-form-label"
}, "Period of Audit:", -1)
const _hoisted_12 = { class: "col-sm-9" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "startMonth",
  class: "col-form-label"
}, "Start Month:", -1)
const _hoisted_16 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_17 = { class: "col" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "endMonth",
  class: "col-form-label"
}, "End Month:", -1)
const _hoisted_19 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_20 = { class: "mb-3 row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "disabledTextInput",
  class: "col-sm-3 col-form-label"
}, "Audit to Take Place:", -1)
const _hoisted_22 = { class: "col-sm-9" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "startDate",
  class: "col-form-label"
}, "Start Date:", -1)
const _hoisted_26 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_27 = { class: "col" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "plannedEndDate",
  class: "col-form-label"
}, "Planned End Date:", -1)
const _hoisted_29 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_30 = { class: "mb-3 row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  for: "auditorName",
  class: "col-sm-3 col-form-label"
}, "Auditor Name:", -1)
const _hoisted_32 = { class: "col-sm-9" }
const _hoisted_33 = { class: "mb-3 row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  for: "disabledTextInput",
  class: "col-sm-3 col-form-label"
}, "Auditor Email Address:", -1)
const _hoisted_35 = { class: "col-sm-9" }
const _hoisted_36 = { class: "mb-3 row align-items-start" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", {
  for: "disabledSelect",
  class: "col-sm-3 col-form-label"
}, "Notices:", -1)
const _hoisted_38 = { class: "col-sm-9 mt-2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Cancel"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary",
    type: "submit"
  }, "Save")
], -1)
const _hoisted_40 = { class: "mt-5 mb-3 details" }
const _hoisted_41 = { class: "table-sm mb-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("th", null, "Agency:", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("th", null, "Status:", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("th", null, "Period of Audit:", -1)
const _hoisted_45 = { class: "val" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "me-1 ms-1" }, " through ", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("th", null, "Audit to Take Place:", -1)
const _hoisted_48 = { class: "val" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "me-1 ms-1" }, " to ", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Auditor Contact Details:")
], -1)
const _hoisted_51 = { colspan: "2" }
const _hoisted_52 = { class: "col-12 offset-3 pb-0 pt-0" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "col col-auto col-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-bold" }, "Name:")
], -1)
const _hoisted_55 = { class: "col" }
const _hoisted_56 = { class: "val" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "col col-auto col-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-bold" }, "Email:")
], -1)
const _hoisted_59 = { class: "col" }
const _hoisted_60 = { class: "val" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("th", null, "Notices:", -1)
const _hoisted_62 = {
  key: 0,
  class: "val"
}
const _hoisted_63 = {
  key: 1,
  class: "val"
}
const _hoisted_64 = ["href"]

import { Audit, AuditEdit } from "@/audit.types";
import { useAuditStore } from "@/stores/auditStore";
import { clone } from "@/utils";
import { useFormValidation } from "@/validation";
import { computed, onMounted, ref } from "vue";
import { date, mixed, object, string } from "yup";
import InformationModal from "../Misc/InformationModal.vue";
import TextInput from "../Fields/TextInput.vue";
import FileInput from "../Fields/FileInput.vue";
import Datepicker from "@vuepic/vue-datepicker";
import AuditDetailsNotices from "./AuditDetailsNotices.vue";

const dateFormat = "yyyy-MM-dd";

export default /*#__PURE__*/_defineComponent({
  __name: 'AuditDetailsGeneral',
  props: {
    id: {},
    audit: {},
    runAudits: { type: Boolean },
    createAudits: { type: Boolean }
  },
  emits: ["reload"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const auditStore = useAuditStore();
const editAudit = ref<AuditEdit>();
const uploadReportFile = ref<File | null>();

const schema = object<AuditEdit>({
    startDate: date().required().label("Start Date"),
    startMonth: date().required().label("Start Month"),
    auditorName: string().required().label("Auditor Name"),
    auditEmailAddress: string().email().label("Audit Email Address"),
});
const canShowCancel = computed(
    () =>
        props.runAudits &&
        (props.audit.statusCode == "AN" || props.audit.statusCode == "AP") &&
        (!props.audit.documents || props.audit.documents == 0)
);
const canShowClose = computed(
    () =>
        props.runAudits &&
        props.audit.statusCode == "AP" &&
        props.audit.documents &&
        props.audit.documents != 0
);

const closeAudit = async function () {
    await auditStore.close(props.id!);
    await fetchDetails();
};
const canViewReport = computed(() => props.audit.reportFileId);

const canUploadReport = computed(
    () =>
        props.runAudits &&
        props.audit.statusCode != "AC" &&
        !props.audit.reportFileId
);

const canReplaceReport = computed(
    () =>
        props.runAudits &&
        props.audit.reportFileId &&
        props.audit.statusCode != "AC"
);

const canEdit = computed(
    () => props.runAudits && props.audit.statusCode != "AC"
);

const isShowUploadReport = ref(false);

const showUploadReport = function () {
    isShowUploadReport.value = true;
};

const hideUploadReport = function () {
    isShowUploadReport.value = false;
};

const { handleSubmit, errors } = useFormValidation();

const uploadReportSchema = object().shape({
    file: mixed().required().label("File"),
});

const uploadReport = async function () {
    if (
        await handleSubmit(uploadReportSchema, { file: uploadReportFile.value })
    ) {
        await auditStore.upload(props.id!, uploadReportFile.value!);
        hideUploadReport();
        await fetchDetails();
        uploadReportFile.value = null;
    }
};

const isShowEditEditor = ref(false);

const showEditEditor = function () {
    isShowEditEditor.value = true;
};
const hideEditEditor = function () {
    isShowEditEditor.value = false;
};

const updateAudit = async () => {
    if (await handleSubmit(schema, editAudit.value)) {
        await auditStore.update(props.id, editAudit.value);
        await fetchDetails();
        await hideEditEditor();
    }
};

onMounted(() => {
    editAudit.value = <AuditEdit>(<unknown>clone(props.audit));
    let date = new Date(props.audit.startMonth);
    startMonth.value = {
        month: date.getMonth(),
        year: date.getFullYear(),
    };
    date = new Date(props.audit.endMonth);
    endMonth.value = {
        month: date.getMonth(),
        year: date.getFullYear(),
    };
});

const fetchDetails = async () => {
    emit("reload");
};

const startMonth = ref();
const endMonth = ref();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(InformationModal, {
      title: "Upload Report",
      "show-modal": isShowUploadReport.value,
      onDismiss: hideUploadReport
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(uploadReport, ["prevent"])
        }, [
          _createElementVNode("fieldset", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createVNode(FileInput, {
                  modelValue: uploadReportFile.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((uploadReportFile).value = $event)),
                  id: "uploadReportFile",
                  name: "uploadReportFile",
                  error: _unref(errors).file
                }, null, 8, ["modelValue", "error"])
              ])
            ])
          ]),
          _hoisted_5
        ], 32)
      ]),
      _: 1
    }, 8, ["show-modal"]),
    (editAudit.value)
      ? (_openBlock(), _createBlock(InformationModal, {
          key: 0,
          title: "Edit Audit",
          "show-modal": isShowEditEditor.value,
          onDismiss: hideEditEditor
        }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _withModifiers(updateAudit, ["prevent"])
            }, [
              _createElementVNode("fieldset", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, _toDisplayString(editAudit.value.agencyName), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createVNode(_unref(Datepicker), {
                          modelValue: startMonth.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startMonth).value = $event)),
                          clearable: false,
                          "enable-time-picker": false,
                          class: _normalizeClass({ 'is-invalid': !!_unref(errors).startMonth}),
                          "month-picker": true,
                          format: "MM-yyyy",
                          "input-class-name": !!_unref(errors).startMonth?'form-control is-invalid':'form-control'
                        }, null, 8, ["modelValue", "class", "input-class-name"]),
                        (_unref(errors).startMonth)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(errors).startMonth), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode(_unref(Datepicker), {
                          modelValue: endMonth.value,
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => ((endMonth).value = $event)),
                            _cache[3] || (_cache[3] = ($event: any) => (editAudit.value.endMonth=new Date(endMonth.value.year, endMonth.value.month, 0)))
                          ],
                          clearable: false,
                          "month-picker": true,
                          format: "MM-yyyy",
                          class: _normalizeClass({ 'is-invalid': !!_unref(errors).endMonth}),
                          "enable-time-picker": false,
                          "input-class-name": !!_unref(errors).endMonth?'form-control is-invalid':'form-control'
                        }, null, 8, ["modelValue", "class", "input-class-name"]),
                        (_unref(errors).endMonth)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(errors).endMonth), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createVNode(_unref(Datepicker), {
                          format: dateFormat,
                          modelValue: editAudit.value.startDate,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editAudit.value.startDate) = $event)),
                          id: "startDate",
                          clearable: false,
                          class: _normalizeClass({ 'is-invalid': !!_unref(errors).startDate}),
                          "enable-time-picker": false,
                          "input-class-name": !!_unref(errors).startDate?'form-control is-invalid':'form-control'
                        }, null, 8, ["modelValue", "class", "input-class-name"]),
                        (_unref(errors).startDate)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(errors).startDate), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createVNode(_unref(Datepicker), {
                          format: dateFormat,
                          id: "plannedEndDate",
                          modelValue: editAudit.value.plannedEndDate,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editAudit.value.plannedEndDate) = $event)),
                          clearable: false,
                          "enable-time-picker": false,
                          "input-class-name": !!_unref(errors).plannedEndDate?'form-control is-invalid':'form-control'
                        }, null, 8, ["modelValue", "input-class-name"]),
                        (_unref(errors).plannedEndDate)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(errors).plannedEndDate), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(TextInput, {
                      name: "auditorName",
                      type: "text",
                      modelValue: editAudit.value.auditorName,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editAudit.value.auditorName) = $event)),
                      error: _unref(errors).auditorName
                    }, null, 8, ["modelValue", "error"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(TextInput, {
                      name: "auditorName",
                      type: "text",
                      modelValue: editAudit.value.auditorEmailAddress,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editAudit.value.auditorEmailAddress) = $event)),
                      error: _unref(errors).auditorEmailAddress
                    }, null, 8, ["modelValue", "error"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(AuditDetailsNotices, {
                      "run-audits": _ctx.runAudits,
                      modelValue: editAudit.value.notices,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editAudit.value.notices) = $event)),
                      "create-audits": _ctx.createAudits,
                      audit: _ctx.audit,
                      id: _ctx.id
                    }, null, 8, ["run-audits", "modelValue", "create-audits", "audit", "id"])
                  ])
                ])
              ]),
              _hoisted_39
            ], 32)
          ]),
          _: 1
        }, 8, ["show-modal"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("table", _hoisted_41, [
        _createElementVNode("tr", null, [
          _hoisted_42,
          _createElementVNode("td", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.audit.agencyName), 1)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_43,
          _createElementVNode("td", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.audit.status), 1)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_44,
          _createElementVNode("td", null, [
            _createElementVNode("span", _hoisted_45, [
              _createTextVNode(_toDisplayString(_ctx.audit.startMonth) + " ", 1),
              _hoisted_46,
              _createTextVNode(" " + _toDisplayString(_ctx.audit.endMonth), 1)
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_47,
          _createElementVNode("td", null, [
            _createElementVNode("span", _hoisted_48, [
              _createTextVNode(_toDisplayString(_ctx.audit.startDate) + " ", 1),
              _hoisted_49,
              _createTextVNode(" " + _toDisplayString(_ctx.audit.plannedEndDate), 1)
            ])
          ])
        ]),
        _hoisted_50,
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.audit.auditorName), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.audit.auditorEmailAddress), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_61,
          _createElementVNode("td", null, [
            (_ctx.audit.notifications)
              ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.audit.notifications) + " notice types enabled", 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_63, "No notice type enabled"))
          ])
        ])
      ]),
      (canEdit.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            onClick: _withModifiers(showEditEditor, ["prevent"]),
            class: "btn btn-primary me-2"
          }, "Edit"))
        : _createCommentVNode("", true),
      (canShowClose.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            onClick: _withModifiers(closeAudit, ["prevent"]),
            class: "btn btn-danger me-2"
          }, "Close Audit"))
        : _createCommentVNode("", true),
      (canUploadReport.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            onClick: showUploadReport,
            class: "btn btn-primary me-2"
          }, "Upload Report"))
        : _createCommentVNode("", true),
      (canShowCancel.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            type: "button",
            onClick: _withModifiers(closeAudit, ["prevent"]),
            class: "btn btn-danger me-2"
          }, "Cancel Audit"))
        : _createCommentVNode("", true),
      (canViewReport.value)
        ? (_openBlock(), _createElementBlock("a", {
            key: 4,
            href: `api/v1/audit/file/${_ctx.audit.reportFileId}`,
            class: "btn btn-secondary"
          }, "View Report", 8, _hoisted_64))
        : _createCommentVNode("", true),
      (canReplaceReport.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 5,
            type: "button",
            onClick: showUploadReport,
            class: "btn btn-primary mx-2"
          }, "Replace Report"))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})